/** Lowercase + remove spaces (incl. NBSP / unicode space) — postcodes vary in spacing. */
function compactSpaces(s) {
  return String(s || '')
    .normalize('NFC')
    .toLowerCase()
    .replace(/[\s\u00a0\u2000-\u200b\u202f\u205f\u3000\ufeff]+/g, '');
}

/** Letters + digits only — matches across newlines, HTML breaks, commas, hyphens between tokens. */
function alnumKey(s) {
  return String(s || '')
    .normalize('NFC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '');
}

function rowMatchesHaystack(parts, needle) {
  const hayRaw = parts.map((s) => String(s || '').toLowerCase()).join('\u0000');
  if (hayRaw.includes(needle)) return true;

  const needleSp = compactSpaces(needle);
  if (needleSp && parts.map((p) => compactSpaces(p)).join('').includes(needleSp)) return true;

  const needleKey = alnumKey(needle);
  if (!needleKey) return false;
  const hayKey = parts.map((p) => alnumKey(p)).join('');
  return hayKey.includes(needleKey);
}

/** Case-insensitive match on order fields + tolerant postcode / multi-line address (NL). */
export function orderMatchesGlobalSearch(order, rawQuery) {
  const needle = String(rawQuery || '').trim().toLowerCase();
  if (!needle) return true;
  const parts = [
    order?.client_name,
    order?.address,
    order?.postcode,
    order?.phone,
    order?.email,
    order?.offer_id,
    order?.id != null ? String(order.id) : '',
  ];
  return rowMatchesHaystack(parts, needle);
}

export function offerMatchesGlobalSearch(offer, rawQuery) {
  const needle = String(rawQuery || '').trim().toLowerCase();
  if (!needle) return true;
  const c = offer?.contact || {};
  const parts = [
    c.name,
    c.address,
    c.postcode,
    c.phone,
    c.email,
    offer?.offer_number,
    offer?.id,
    offer?.reference,
  ];
  return rowMatchesHaystack(parts, needle);
}
